import * as THREE from "three";
import Heatpoint from '../heatpointscontrol/heatpoint'
import gsap from "gsap";

const ANIMATION_NAMES = ['BrüückeAction', 'ass brücke.001Action.001'];

export default class bridge extends THREE.Object3D {
	constructor(pinColor, pinColorDark, camera, interactionManager, onPinClick, gltfanimations, mixer,visitedPinColor) {
		super();
	
		this.pinModel8 = new Heatpoint(null, "model/heatointbrige.glb") 
        setTimeout(() => {
            this.pinModel8.setColor(pinColor);
        }, 1000);
		this.pinModel8.position.set(0.6, 0.40, 0.92);
        this.visited = false;
		interactionManager.add(this.pinModel8);

		this.pinModel8.addEventListener("click", (event) => {
			onPinClick();
			gsap.to(camera.position,  { x: 1.0, y: 0.7, z: 1.8, duration: 2.5, ease: "Power3.inOut" })
            this.triggerAnimations(gltfanimations, mixer, true);
            this.visited = true;     
            this.pinModel8.setColor(visitedPinColor);
		})
        
		this.pinModel8.addEventListener('mouseover', (event) => {
			document.body.style.cursor = 'pointer';
			this.pinModel8.setColor(pinColorDark);
		});

		this.pinModel8.addEventListener('mouseout', (event) => {
			document.body.style.cursor = 'default';
            if(!this.visited){
                this.pinModel8.setColor(pinColor);
            }
            else{
				this.pinModel8.setColor(visitedPinColor);
			}
		});
		this.add(this.pinModel8)
    	this.rotatePin();
	}

    getClipActions(gltfanimations, mixer) {
		return ANIMATION_NAMES.map(name => {
			const animation = THREE.AnimationClip.findByName(gltfanimations, name);
			return mixer.clipAction(animation);
		});
	}
    
    triggerAnimations(gltfanimations, mixer, modal) {
		const clipActions = this.getClipActions(gltfanimations, mixer);
		setTimeout(() => {
			clipActions.forEach(clip => {
				clip.reset().timeScale = 1;
				clip.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
				if (modal) {
					setTimeout(() => {
						const modal8 = document.getElementById('modal8');
						modal8.classList.remove('hidden');
					}, 10000);
				}
				const modal8 = document.getElementById('modal8');
				modal8.addEventListener('click', function() {
					modal8.classList.add('hidden');
					clipActions.forEach(clip => clip.reset().timeScale = -1);
				});
			});
		}, 1500);
		const startIndex = 35;
		const endIndex = 35;
		const animations = gltfanimations;
		const actions = [];
		
		for (let i = startIndex; i <= endIndex; i++) {
			const clip = animations[i];
			const action = mixer.clipAction(clip);
			actions.push(action);
		}
		actions.forEach(action => {
			action.reset();
			action.timeScale = 1; // Play the animation backwards
			action.play().setLoop(THREE.LoopOnce, 1).clampWhenFinished = true;
		});

	}

	resetAnimations(gltfanimations, mixer) {
		const clipActions = this.getClipActions(gltfanimations, mixer);
		clipActions.forEach(clip => clip.reset().timeScale = -1);
	}

	rotatePin() {
        this.rotationData = { angle: 0 };
        gsap.to(this.rotationData, {
            angle: "+=" + 2 * Math.PI, // Add 360 degrees in radians
            duration: 10, // Define how fast you want a full rotation to be. Here it's set to 5 seconds.
            ease: "none", // Linear rotation
            onUpdate: () => {
                this.pinModel8.setRotationFromAxisAngle(new THREE.Vector3(0, 1, 0), this.rotationData.angle);
            },
            repeat: -1 // This will make the animation run indefinitely
        });
	}
}